export default __webpack_public_path__ + "static/media/VaxTrack-Privacy_Policy.6a9cf076.pdf";